// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"654db5fa","298":"8baa1d98","397":"dd3da954","727":"1fbd97e2","766":"121c30d0","913":"7fa57c77","920":"6bb887b9"}[chunkId] + ".chunk.css";
};